function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 0.25rem;\n  color: ",
        ";\n  font-style: italic;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
var InputErrorComponent = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.error;
});
var InputError = function(param) {
    var children = param.children;
    return /*#__PURE__*/ React.createElement(InputErrorComponent, {
        className: "wr__input-error"
    }, children);
};
export default InputError;
